import React, { useContext, useEffect } from 'react'
import { Container } from 'reactstrap'
import { withRouter } from 'react-router-dom'
import { GeneralContext } from '../../context/'
import FramesManager from './components/FramesManager'

const Index = () => {
    const { setBreadcrumb } = useContext(GeneralContext)

    useEffect(() => {
        setBreadcrumb({
            icon: '',
            parent: 'Marcos',
            parentLink: '/frames',
            item: 'Marcos'
        })
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <FramesManager />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(Index)
